module.exports = __webpack_public_path__ + "static/media/logo.c3a24fb8.png";